import GoogleFundingIframe from 'app/components/layouts/Google/GoogleFundingIframe';
import Analytics from 'app/components/layouts/Google/Analytics';
import ChatComponent from 'app/components/layouts/Messenger/Chat';
import LoadingOver from 'app/components/layouts/LoadingOver';
import Header from 'app/components/layouts/Header/Index';
import Footer from 'app/components/layouts/Footer/Index';
import { Sidebar } from 'app/components/layouts/Sidebar';
import { useSelector, useDispatch } from 'react-redux';
import * as commonActions from 'app/actions/commons';
import 'react-datepicker/dist/react-datepicker.css';
import { AppStoreState } from 'app/redux/store';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { pageview } from 'app/utils/ga';
import { useEffect } from 'react';
import Router from "next/router";
import env from ".env.json";

import dynamic from "next/dynamic";
const DictionaryTooltip = dynamic(() => import('app/components/vocabularies/DictionanyTooltip'), { ssr: false });

const index = ({ children }) => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state: AppStoreState) => state.commons);
  const { deviceType } = useSelector((state: AppStoreState) => state.global);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/service-worker.js').
        then(function (registration) {
          console.log('ServiceWorker registration successful with scope: ',
            registration.scope);
        }).catch(function (err) {
          console.log('ServiceWorker registration failed: ', err);
        });
    }

    const start = () => {
      dispatch(commonActions.setLoading(true));
    };

    const end = () => {
      dispatch(commonActions.setLoading(false));
    };

    const handleRouteChange = (url: string) => {
      pageview(url)
    }

    Router.events.on("routeChangeStart", start);
    Router.events.on("routeChangeComplete", end);
    Router.events.on("routeChangeError", end);
    Router.events.on('routeChangeComplete', handleRouteChange)
    return () => {
      Router.events.off("routeChangeStart", start);
      Router.events.off("routeChangeComplete", end);
      Router.events.off("routeChangeError", end);
      Router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, []);

  return (
    <LoadingOver loading={loading} >
      <Header />
      <div className="container-md">
        {(deviceType !== 'mobile' || env.ENV == 'dev') &&
          <Sidebar />
        }
        <div id="RouterViewWeb" className="bg-white">{children}</div>
        <DictionaryTooltip />
      </div>
      <div id='dictionary' />
      <ToastContainer theme="colored" />
      <ChatComponent />
      <Footer />
      <Analytics />
      <GoogleFundingIframe />
    </LoadingOver>
  )
}

export default index;
